import { render, staticRenderFns } from "./DocumentSlot.vue?vue&type=template&id=25f40576&"
import script from "./DocumentSlot.vue?vue&type=script&lang=js&"
export * from "./DocumentSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports